import { render, staticRenderFns } from "./gaia-viewer.vue?vue&type=template&id=37a4b8aa&scoped=true&"
import script from "./gaia-viewer.vue?vue&type=script&lang=js&"
export * from "./gaia-viewer.vue?vue&type=script&lang=js&"
import style0 from "./gaia-viewer.vue?vue&type=style&index=0&id=37a4b8aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4b8aa",
  null
  
)

export default component.exports